module.exports = __webpack_public_path__ + "assets/c6b89dfab7fdb0e2dd18d3ed998f7ff6.jpg";